/* eslint-disable jsx-a11y/anchor-is-valid */

import TemplateSetList from "@components/dashboard/shippingProfile/templateSetList";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { AppBar, Box, Stack } from "@mui/material";
import Button from "@mui/material/Button";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import ems from "public/image/shipping_company/china-ems.svg";
import dhl from "public/image/shipping_company/dhl.svg";
import fedex from "public/image/shipping_company/fedex.svg";
import yunexpress from "public/image/shipping_company/yunexpress.svg";
// import Avatar from '@mui/material/Avatar';
import { initAppData } from "@utils/initAppData";
import { NextSeo } from "next-seo";
import Link from "next/link";
import { useRef, useState } from "react";
// import PropTypes from 'prop-types';
import Layout from "layout/landingPage";
import staticImageLoader from "lib/staticImageLoader";
import Image from "next/image";
import bg from "public/image/bkgd-howitworks.svg";
import { connect, useSelector } from "react-redux";

const styles = (theme) => ({
  root: {
    paddingTop: 0,
    maxWidth: 1200,
    margin: "auto",
  },
  cover: {
    background: `url(${bg}) center no-repeat`,
    backgroundSize: "cover",
    backgroundPosition: "bottom",
    position: "relative",
    color: "white",
    padding: 80,
    [theme.breakpoints.down("sm")]: {
      padding: "70px 15px 70px 15px",
    },
    "& text": {
      textAlign: "left",
    },
  },
  coverText: {
    textAlign: "center",
    margin: "auto",
    maxWidth: 580,
    marginTop: 100,
    // float: 'right',
  },
  link: {
    textDecoration: "none",
  },
  rightIcon: {
    marginLeft: 10,
  },
  button: {
    marginTop: 20,
    // padding: 20,
    height: 52,
    color: "#ffffff",
    background: "#3C4858",
    backgroundColor: "#3C4858",
    border: "2px solid #3C4858",
    "&:hover": {
      background: "#272f3a",
      backgroundColor: "#272f3a",
      border: "2px solid #272f3a",
    },
  },
  section: {
    marginTop: 30,
  },
  carrierLogo: {
    width: 60,
    height: 60,
    margin: 8,
  },
  carrierList: {
    marginTop: 16,
    marginLeft: "auto",
    marginRight: "auto",
    width: 320,
  },
  head: {
    padding: "16px 16px",
  },
  flexContainer: {
    background: "#ffffff",
  },
  appBarRoot: {
    boxShadow: "none",
    borderBottom: "1px solid #e8e8e8",
  },
});

function Shipping(props) {
  const templateSetList = useRef();
  const [tab, setTab] = useState(0);
  const { shippingPrices, classes } = props;

  const app = useSelector((store) => store.app);

  function handleChange(index) {
    setTab(index);

    templateSetList.current.sortCategory(
      shippingPrices.shipping_profiles[index].rates
    );
  }

  return (
    <Layout app={app}>
      <NextSeo
        title={`Shipping Speeds & Pricing | Printy6`}
        description={`Learn about our shipping methods, shipping speeds, and shipping prices for products made by Printy6 or stored at our warehousing &amp; fulfillment centers`}
        canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/shipping`}
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_SITE_URL}/shipping`,
          type: "article",
        }}
      />
      <Box>
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              zIndex: -1,
            }}
          >
            <Image
              src={bg}
              layout="fill"
              objectFit="cover"
              position="absolute"
              loader={staticImageLoader}
            />
          </Box>
          <Box>
            <Box sx={{ pt: "100px", pb: "60px", textAlign: "center" }}>
              <Box
                sx={{
                  maxWidth: 580,
                  mx: "auto",
                  color: (theme) => theme.palette.common.white,
                }}
              >
                <Typography
                  component="h1"
                  variant="h3"
                  gutterBottom
                  color="inherit"
                >
                  Shipping rates and delivery times
                </Typography>
                <Typography variant="h5" gutterBottom color="inherit">
                  Flexible shipping options and best price is our important
                  serving content.
                </Typography>
                <Link href="/login">
                  <a href="/login" className={classes.link}>
                    <Button
                      disableElevation
                      variant="contained"
                      className={classes.button}
                    >
                      Get started
                      <CloudUploadIcon className={classes.rightIcon} />
                    </Button>
                  </a>
                </Link>
              </Box>
            </Box>
          </Box>
        </Box>
        <div className={classes.root}>
          <div className={classes.section}>
            <div>
              <Typography variant="h6" gutterBottom align="center">
                We partner with these global carriers to give you the best
                shipping experience
              </Typography>
              <Stack
                spacing={2}
                direction="row"
                sx={{ justifyContent: "center" }}
              >
                <div>
                  <Image
                    src={ems}
                    width={60}
                    height={60}
                    alt="ems"
                    loader={staticImageLoader}
                  />
                </div>
                <div>
                  <Image
                    src={dhl}
                    width={60}
                    height={60}
                    alt="dhl"
                    loader={staticImageLoader}
                  />
                </div>
                <div>
                  <Image
                    src={yunexpress}
                    width={60}
                    height={60}
                    alt="yunexpress"
                    loader={staticImageLoader}
                  />
                </div>
                <div>
                  <Image
                    src={fedex}
                    width={60}
                    height={60}
                    alt="fedex"
                    loader={staticImageLoader}
                  />
                </div>
              </Stack>
            </div>
          </div>
          <div className={classes.head}>
            <AppBar
              position="static"
              color="default"
              classes={{
                root: classes.appBarRoot,
              }}
            >
              <Tabs
                value={tab}
                indicatorColor="primary"
                textColor="primary"
                aria-label="full width tabs example"
                classes={{
                  flexContainer: classes.flexContainer,
                }}
              >
                {shippingPrices.shipping_profiles.map((profile, i) => (
                  <Tab
                    onClick={(index) => handleChange(i)}
                    label={profile.name}
                    key={i}
                  />
                ))}
              </Tabs>
            </AppBar>
          </div>
          <TemplateSetList
            ref={templateSetList}
            rates={shippingPrices.shipping_profiles[tab].rates}
          />
        </div>
      </Box>
    </Layout>
  );
}

Shipping.getInitialProps = async (ctx) => {
  const isServer = !!ctx.req;

  await initAppData(ctx);

  await ctx.reduxStore.execSagaTasks(isServer, (dispatch) => {
    dispatch({ type: "EFFECT_SHIPPING_PRICES_LOAD", payload: ctx.query });
  });

  return {};
};

function mapStateToProps(state) {
  const { shippingPrices } = state;
  return { shippingPrices };
}

export default connect(mapStateToProps)(withStyles(styles)(Shipping));
